var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNh46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3327 7L22.9994 10.1742L16.666 7L22.9994 18.9954L29.3327 7Z",
    fill: "#FFB71B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.593 16.2302L36.1115 14.3478V7.99951L28.2596 11.3582L23.8892 19.552C25.5705 19.7452 27.114 20.5718 28.2035 21.8625C29.2929 23.1533 29.8458 24.8103 29.7487 26.4942C29.6516 28.178 28.912 29.7611 27.6814 30.919C26.4508 32.0769 24.8224 32.722 23.13 32.722C21.4375 32.722 19.8092 32.0769 18.5786 30.919C17.348 29.7611 16.6084 28.178 16.5113 26.4942C16.4142 24.8103 16.9669 23.1533 18.0564 21.8625C19.1458 20.5718 20.6893 19.7452 22.3707 19.552L18.0003 11.3582L10.1855 7.99951V14.3478L14.7781 16.2302C12.7863 17.9652 11.3731 20.2645 10.7272 22.8211C10.0812 25.3776 10.2333 28.0696 11.1631 30.5377C12.093 33.0058 13.7563 35.1325 15.931 36.6337C18.1057 38.135 20.6882 38.9393 23.3337 38.9393C25.9791 38.9393 28.5616 38.135 30.7363 36.6337C32.911 35.1325 34.5743 33.0058 35.5042 30.5377C36.434 28.0696 36.5862 25.3776 35.9402 22.8211C35.2943 20.2645 33.881 17.9652 31.8892 16.2302H31.593Z",
    fill: "#FFB71B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNh46);
export default __webpack_public_path__ + "static/media/NH농협-46.0d6cf80d6aa7a1dfc956b1f22005527a.svg";
export { ForwardRef as ReactComponent };